<template>
  <VaCard>
    <VaCardTitle>
      <h3 class="mb-3 font-bold text-lg" style="text-transform: none">Eventos muelle</h3>
    </VaCardTitle>
    <VaCardContent class="h-full scrollable-table">
      <table class="mt-4">
        <tbody>
          <template v-for="(pos, index) in displayList" :key="'operationTimeline_' + index">
            <VaTimelineItem
              v-if="pos.operacion === 'posicionamientoViaje' && pos.viaje"
              :key="'operationTimeline_' + index + '-posicionamiento'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Nave <b>{{ pos.viaje.embarcacionData?.nombre_embarcacion }}</b> se posicionó en el
              <b>{{ pos.viaje.muelle }}</b> para el viaje gobernado por
              <b>{{ pos.viaje.patronData?.nombre_completo }}</b>
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'zarpe' && pos.viaje"
              :key="'operationTimeline_' + index + '-zarpe'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Nave <b>{{ pos.viaje.embarcacionData?.nombre_embarcacion }}</b> zarpó del
              <b>{{ pos.viaje.muelle }}</b> gobernado por
              <b>{{ pos.viaje.patronData?.nombre_completo }}</b>
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'aterrizaje' && pos.viaje"
              :key="'operationTimeline_' + index + '-aterrizaje'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Nave <b>{{ pos.viaje.embarcacionData?.nombre_embarcacion }}</b> atracó en el <b>{{ pos.viaje.muelle }}</b>
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'salida' && pos.viaje"
              :key="'operationTimeline_' + index + '-salida'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Nave <b>{{ pos.viaje.embarcacionData?.nombre_embarcacion }}</b> salió del <b>{{ pos.viaje.muelle }}</b>
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'solicitud' && pos.servicio"
              :key="pos.servicio.id + '-solicitud'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Se solicitó el servicio de <b>"{{ pos.servicio.motivo_solicitud }}"</b> para el
              <b>{{
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              }}</b>
              con una embarcación de tipo <b>{{ pos.servicio.tipo_embarcacion }}</b
              >.
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'respuesta' && pos.servicio"
              :key="pos.servicio.id + '-respuesta'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Se {{ pos.servicio.requestData?.estado == RequestStatus.APPROVED ? 'aprobó' : 'rechazó' }} el servicio de
              <b>"{{ pos.servicio.motivo_solicitud }}"</b> para el
              <b>{{
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              }}</b>
              con una embarcación de tipo <b>{{ pos.servicio.tipo_embarcacion }}</b
              >.
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'tarifa_especial' && pos.servicio"
              :key="pos.servicio.id + '-tarifa_especial'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              Se aprobó una tarifa especial para la embarcación de tipo
              <b>{{ pos.servicio.tipo_embarcacion }}</b> en el servicio de <b>"{{ pos.servicio.motivo_solicitud }}"</b>.
            </VaTimelineItem>
            <VaTimelineItem
              v-else-if="pos.operacion === 'posicionamientoServicio' && pos.servicio"
              :key="pos.servicio.id + '-posicionamiento'"
              :date="
                pos.eventDate.toLocaleDateString([], {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              "
            >
              La embarcación de tipo <b>{{ pos.servicio.tipo_embarcacion }}</b> fue posicionada para el servicio de
              <b>"{{ pos.servicio.motivo_solicitud }}"</b>.
            </VaTimelineItem>
          </template>
        </tbody>
      </table>
      <div v-if="visibleCount < showList.length" class="flex justify-center mt-4">
        <VaButton preset="secondary" size="small" @click="visibleCount += 20"> Mostrar más </VaButton>
      </div>
    </VaCardContent>
  </VaCard>
</template>
<script setup lang="ts">
import { onMounted, ref, Ref, watch, computed } from 'vue'
import VaTimelineItem from '../../../components/va-timeline-item.vue'
import dataStorageManager, { BucketDefaultIDs } from '../../../managers/data/DataStorageManager'
import dataHubServices from '../../../services/data-hub-services/DataHubServices'
import { viajesHubName, ViajesHubPipelines } from '../../../services/data-hub-services/ViajesHub'
import { IRequest, RequestObjectType, RequestStatus } from '../../../services/api-services/RequestsServices'
import { OperatedViaje } from '../../../services/api-services/ViajesServices'
import { IService, OperatedService } from '../../../services/api-services/ServicesServices'

const fullViajesList: Ref<OperatedViaje[]> = ref([])
const servicesList: Ref<IService[]> = ref([])
const fullServicesList: Ref<OperatedService[]> = ref([])
const posicionamientosRequests: Ref<IRequest[]> = ref([])
const serviciosRequests: Ref<IRequest[]> = ref([])
const tarifasEspecialesRequests: Ref<IRequest[]> = ref([])

type EventItem = {
  viaje: OperatedViaje | null
  servicio: OperatedService | null
  userName: string | null
  operacion:
    | 'posicionamientoViaje'
    | 'zarpe'
    | 'aterrizaje'
    | 'salida'
    | 'solicitud'
    | 'respuesta'
    | 'tarifa_especial'
    | 'posicionamientoServicio'
  eventDate: Date
  tarifaEspecial: IRequest | undefined
}

const fullList: Ref<EventItem[]> = ref([])
const showList: Ref<EventItem[]> = ref([])
const visibleCount = ref(20)
const displayList = computed(() => showList.value.slice(0, visibleCount.value))

onMounted(() => {
  dataHubServices.subscribeToHub(viajesHubName, {
    subscriberID: 'fullTimeline_viajes',
    pipeline: ViajesHubPipelines.VIAJES_WITH_TRIPULANTES,
    callback: (data: OperatedViaje[]) => {
      fullViajesList.value = data
    },
  })
  dataStorageManager.subscribeBucket(BucketDefaultIDs.SERVICES, (services: IService[]) => {
    servicesList.value = services
    loadFullServices()
  })
  dataStorageManager.subscribeBucket(BucketDefaultIDs.SOLICITUDES, onRequestsLoad)
})

watch([fullViajesList, fullServicesList], () => {
  const viajesEvents = fullViajesList.value
    .map((viaje) => {
      if (viaje.posicionamientosData.length > 0) {
        const posicionamientosViaje: EventItem[] = []
        posicionamientosViaje.push({
          viaje: viaje,
          servicio: null,
          userName: null,
          operacion: 'posicionamientoViaje',
          eventDate: new Date(viaje.fecha_viaje),
          tarifaEspecial: undefined,
        })
        if (viaje.marca_fecha_inicio) {
          posicionamientosViaje.push({
            viaje: viaje,
            servicio: null,
            userName: null,
            operacion: 'zarpe',
            eventDate: new Date(viaje.marca_fecha_inicio as string),
            tarifaEspecial: undefined,
          })
        }
        if (viaje.marca_fecha_fin) {
          posicionamientosViaje.push({
            viaje: viaje,
            servicio: null,
            userName: null,
            operacion: 'aterrizaje',
            eventDate: new Date(viaje.marca_fecha_fin as string),
            tarifaEspecial: undefined,
          })
        }
        if (viaje.marca_salida) {
          posicionamientosViaje.push({
            viaje: viaje,
            servicio: null,
            userName: null,
            operacion: 'salida',
            eventDate: new Date(viaje.marca_salida as string),
            tarifaEspecial: undefined,
          })
        }
        return posicionamientosViaje
      }
    })
    .flat()
    .filter((p) => p !== undefined) as EventItem[]

  const servicesEvents = fullServicesList.value
    .map((service) => {
      const operaciones: EventItem[] = []
      if (service.requestData) {
        operaciones.push({
          viaje: null,
          servicio: service,
          userName: null,
          operacion: 'solicitud',
          eventDate: new Date(service.requestData.fecha_solicitud),
          tarifaEspecial: undefined,
        })
        if (
          service.requestData.estado === RequestStatus.APPROVED ||
          service.requestData.estado === RequestStatus.REJECTED
        ) {
          operaciones.push({
            viaje: null,
            servicio: service,
            userName: null,
            operacion: 'respuesta',
            eventDate: new Date(service.requestData.fecha_respuesta!),
            tarifaEspecial: undefined,
          })
        }
        if (service.tarifasEspecialesData.length > 0) {
          service.tarifasEspecialesData.forEach((tarifa) => {
            operaciones.push({
              viaje: null,
              servicio: service,
              userName: null,
              operacion: 'tarifa_especial',
              eventDate: new Date(tarifa.fecha_solicitud),
              tarifaEspecial: tarifa,
            })
          })
        }
        if (service.posicionamientosData.length > 0) {
          service.posicionamientosData.forEach((posicionamiento) => {
            operaciones.push({
              viaje: null,
              servicio: service,
              userName: null,
              operacion: 'posicionamientoServicio',
              eventDate: new Date(posicionamiento.fecha_solicitud),
              tarifaEspecial: undefined,
            })
          })
        }
      }
      return operaciones
    })
    .flat()
    .filter((p) => p !== undefined) as EventItem[]

  fullList.value = [...viajesEvents, ...servicesEvents]
})

watch(fullList, () => {
  const less12 = new Date(new Date().getTime() - 10 * 1000 * 60 * 60)
  const plus12 = new Date(new Date().getTime() + 24 * 1000 * 60 * 60)
  showList.value = fullList.value
    .sort((a, b) => {
      const dateA = new Date(a.eventDate)
      const dateB = new Date(b.eventDate)
      return dateB.getTime() - dateA.getTime()
    })
    .filter((v, index) => {
      const eventDate = new Date(v.eventDate)
      return (eventDate.getTime() > less12.getTime() && eventDate.getTime() < plus12.getTime()) || index < 15
    })
  visibleCount.value = 20
})

function onRequestsLoad(requests: Array<IRequest>) {
  posicionamientosRequests.value = requests.filter((r) => r.tipo_objeto === RequestObjectType.PosicionamientoServicio)
  serviciosRequests.value = requests.filter((r) => r.tipo_objeto === RequestObjectType.Servicio)
  tarifasEspecialesRequests.value = requests.filter((r) => r.tipo_objeto === RequestObjectType.TarifaEspecial)
  loadFullServices()
}

function loadFullServices() {
  if (servicesList.value.length > 0 && serviciosRequests.value.length > 0) {
    fullServicesList.value = servicesList.value.map((item) => {
      const request: IRequest | undefined = serviciosRequests.value
        .filter((req) => req.tipo_objeto === RequestObjectType.Servicio && req.tipo_objeto_2 === null)
        .filter((req) => req.id_objeto.toString() === item.id.toString())
        .sort((a, b) => new Date(b.fecha_solicitud).getTime() - new Date(a.fecha_solicitud).getTime())[0] // Get latest request
      const posicionamientosRequestsData: IRequest[] = posicionamientosRequests.value
        .filter((r) => r.tipo_objeto === RequestObjectType.PosicionamientoServicio)
        .filter((req) => req.id_objeto.toString() === item.id.toString())
      const tarifasEspecialesRequestsData: IRequest[] = tarifasEspecialesRequests.value.filter(
        (req) => req.id_objeto.toString() === item.id.toString(),
      )

      return {
        ...item,
        requestData: request,
        posicionamientosData: posicionamientosRequestsData,
        tarifasEspecialesData: tarifasEspecialesRequestsData,
        vehiculosData: [],
        vehiculosRequestsData: [],
        usuarioSolicitanteData: undefined,
        embarcacionData: undefined,
      }
    })
  }
}
</script>
<style scoped>
.limited-height-card {
  max-height: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.scrollable-table {
  overflow-y: auto;
  height: 100%;
  max-height: 520px;
}

.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

b {
  color: #4774bd; /* Tailwind's blue-500 color */
}
</style>
